export const API_CONFIG = {
  stripeURL: 'https://api.stripe.com',

  baseURL: process.env.API_BASE_URL || 'http://213.136.70.254', //"http://38.242.254.54", //'https://api.sabily.fr',
  port: process.env.API_PORT || '9070', //'9060', //'443',

  basePath: process.env.API_BASE_PATH || 'api',
  versionPath: process.env.API_VERSION_PATH || 'api/v1'
};

/*export const AUTH_CONFIG = {
  user: {
    username: process.env.USER_LOGIN || 'user',
    password: process.env.USER_PASSWORD || 'user'
  },
  admin: {
    username: process.env.ADMIN_LOGIN || 'admin',
    password: process.env.ADMIN_PASSWORD || 'admin'
  }
};*/

export const ENDPOINTS = {
  subscribers: process.env.SUBSCRIBERS_PATH || 'subscribers',
  packs: process.env.PACKS_PATH || 'packs'
};

export const RECAPTCHA_CONFIG = {
  siteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LfCsG4sAAAAANvrAAKjdvUncsh-UJSraRt0AtEL' // Test key for development
};
